export default function (timestamp) {
  if (!timestamp) return ''
  let day = parseInt(timestamp / (1000 * 60 * 60 * 24));
  let hour = parseInt((timestamp % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let min = parseInt((timestamp % (1000 * 60 * 60)) / (1000 * 60));
  let sec = parseInt((timestamp % (1000 * 60)) / 1000);
  if (hour < 10) hour = '0' + hour
  if (min < 10) min = '0' + min
  if (sec < 10) sec = '0' + sec
  if (!day) return hour + ' : ' + min + ' : ' + sec;
  return day + ' : ' + hour + ' : ' + min + ' : ' + sec;
}